import React from 'react';

import type { EUROPACE_INSURED_RISK } from 'cpool-constants';
import { EUROPACE_INSURED_RISKS } from 'cpool-constants';

import type { SchemaOfferAcceptanceStatusByOfferIdResponse } from '../NewCreditRequest/schemas/schemaOfferAcceptanceStatusByOfferIdResponse';
import { cn } from '~/utils/cnTailwind.ts';

type Props = {
    applicantInsurances: Array<EUROPACE_INSURED_RISK>;
    isOdd: boolean;
    acceptanceStatus?: SchemaOfferAcceptanceStatusByOfferIdResponse | null;
};

export const ApplicantTrafficLight: React.FC<Props> = ({ acceptanceStatus, applicantInsurances, isOdd }) => {
    let borderColor = 'border-white';
    if (acceptanceStatus === 'SUCCESS') {
        borderColor = 'border-green';
    }
    if (acceptanceStatus === 'FAILURE') {
        borderColor = 'border-red';
    }
    // TODO: update tailwind config to configure border colors
    return (
        <div className="flex">
            {[
                EUROPACE_INSURED_RISKS.LEBEN,
                EUROPACE_INSURED_RISKS.ARBEITSUNFAEHIGKEIT,
                EUROPACE_INSURED_RISKS.ARBEITSLOSIGKEIT,
            ].map((key) => (
                <span
                    key={key}
                    data-testid={`applicant-traffic-light-${key}`}
                    className={cn(
                        'block w-[18px] h-[18px] rounded-full border-[1px] right-1.5',
                        applicantInsurances.includes(key) ? 'bg-green' : 'bg-text-input-light',
                        isOdd ? `${borderColor}-light` : `${borderColor}-dark`,
                    )}
                />
            ))}
        </div>
    );
};
